import { useContext } from 'react';
import { MedicalCommitteesContext } from 'Context/MedicalCommitteesContext';
import { ICommitteeLocation } from 'Interfaces/MedicalCommittees';

export const useCommitteeLocation = (committeeLocationId?: number): ICommitteeLocation | undefined => {
  const { stateContent } = useContext(MedicalCommitteesContext);

  if (!committeeLocationId) {
    return undefined;
  }

  return stateContent?.committeeLocations?.find((location) => location.committeeLocationId === committeeLocationId);
};
